<template>
    <div>

        <Head title="Relatório Mensal" />
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input 
                        v-model="filters.MonthlyReport.sales_promoter"
                        :multiple="true"
                        :options="options.salesPromoterSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Promotor" />

                    <multi-select-input
                        v-model="filters.MonthlyReport.market_network"
                        :multiple="true"
                        :options="options.marketNetworkSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Rede" />

                    <multi-select-input
                        v-model="filters.MonthlyReport.market"
                        :multiple="true"
                        :options="options.marketSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Mercado" />

                    <multi-select-input
                        v-model="filters.MonthlyReport.provider"
                        :multiple="true"
                        :options="options.providerSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Fornecedor" />

                    <multi-select-input
                        v-model="filters.MonthlyReport.brand"
                        :multiple="true"
                        :options="options.brandSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Marca" />

                    <multi-select-input
                        v-model="filters.MonthlyReport.product"
                        :multiple="true"
                        :options="options.productSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Produto" />

                    <multi-select-input 
                        v-model="filters.MonthlyReport.city"
                        :multiple="true"
                        :options="options.citysSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Cidade" />
                    
                    <multi-select-input 
                        v-model="filters.MonthlyReport.state"
                        :multiple="true"
                        :options="options.statesSearch"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Estado" />

                    <multi-select-input 
                        class="w-full lg:w-1/4 lg:mt-4"
                        label="Status" 
                        :multiple="false"
                        v-model="filters.MonthlyReport.status"
                        :options="status_options" />
                </div>

                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
                            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                            Pesquisar
                    </button>
                    <button 
                        class="btn flex items-center text-purple-100 font-roboto font-medium uppercase px-6 py-2.5 text-xs leading-tight border-solid border-2 border-purple-100"
                        @click="clearSearch">
                            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                            Limpar
                    </button>
                </div>
            </form>
        </div>
        <h1 class="page-title">Relatório Mensal</h1>

        <div class="report-table-wrapper mt-4">
            <div class="month-pagination-wrapper">
                <font-awesome-icon icon="fa-solid fa-chevron-left" @click="changeMonth(-1)" />
                <p class="capitalize">
                    {{ date.toLocaleDateString('pt-BR', { month: 'long' }) }}, 
                    {{ date.getFullYear() }}
                </p>
                <font-awesome-icon icon="fa-solid fa-chevron-right" @click="changeMonth(1)" />
            </div>
            <div class="table-wrapper">
                <div class="text-right w-full">
                    <button 
                        class="inline-block text-center w-[150px] py-3 px-4 btn-purple"
                        @click="handlerExportXlsx">
                            <font-awesome-icon 
                                icon="fa-table-cells" 
                                class="text-purple text-sm mr-0 lg:mr-2" />
        
                            Exportar xlsx
                    </button>
                </div>
                <data-table 
                    v-if="loadTable"
                    v-model:columns="columns" 
                    route="monthly_report/list" 
                    :query='getQuery()'
                    no-data-label="Nenhuma atividade encontrada" 
                    no-result-label="Nenhuma atividade encontrada">
                        <template #table.cell.content.frequency="rowValue">

                            <month-calendar 
                                title="Calendario"
                                :date="date"
                                :days-week-required="rowValue.row.visit_required"
                                :date-start="rowValue.row.date_start"
                                :date-end="rowValue.row.date_end"
                                :frequency="rowValue.row.frequency" />
                        </template>
                </data-table>
            </div>
        </div>
    </div>
    <Modal
        size="modal-lg"
        ref="showModalXlsx">
            <template #header>
                <div class="text-gray-777 font-roboto uppercase w-full">
                    Historico de arquivos xlsx exportados
                </div>
            </template>

            <template #body>
                <p>Deseja exportar um novo arquivo? </p>
                <button 
                    class="inline-block text-center w-[150px] py-3 px-4 btn-purple mt-4"
                    @click="handlerSendToExportData">
                        <font-awesome-icon 
                            icon="fa-table-cells" 
                            class="text-purple text-sm mr-0 lg:mr-2" />

                        Exportar 
                </button>

                <data-table
                    v-if="exportedTable"
                    v-model:columns="columnsExported" 
                    route="monthly_report/export"
                    no-data-label="Nenhum registro encontrado"
                    no-result-label="Nenhum registro encontrado"
                    class="data-table">

                    <template #table.cell.content.actions="{ value, row }">
                        <button 
                            @click="downloadExportedFile(row.id)" 
                            class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm mr-4">
                                <font-awesome-icon icon="fa-download" class="text-white px-2" />
                        </button>

                        <button 
                            @click="deleteExportedFile(row.id)"
                            class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                                <font-awesome-icon icon="fa-trash-can" class="text-white px-2" />
                        </button>
                    </template>
                </data-table>
            </template>
            <template #footer>
              <button type="button"
                  class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                  @click.prevent="closeModalExport">Cancelar</button>
              
          </template>
    </Modal>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import DataTable from '@/Shared/DataTable'
import SelectInput from '@/Shared/SelectInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import FormFilter from '@/Shared/FormFilter'
import TooltipInfo from '@/Shared/TooltipInfo'
import TextInput from '@/Shared/TextInput'
import MonthCalendar from '@/Shared/MonthCalendar.vue'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'
import Modal from '@/Shared/Modal'
import axios from 'axios'

export default {
  components: {
    Head,
    DataTable,
    SelectInput,
    FormFilter,
    TooltipInfo,
    TextInput,
    MonthCalendar,
    MultiSelectInput,
    Modal,
  },

  mixins: [
    getFiltersMixin,
  ],

  layout: Layout,

  

  data () {
    return {
      status_options: [
        { value: 1, label: 'Visita concluída' },
        { value: 2, label: 'Visita não concluída' },
      ],

      loadTable: true,
      exportedTable: true,
      columnsExported: [
        {
          uniqid: 'date',
          label: 'Gerado',
          field: 'created_at',
          visible: true,
          sortable: false,
          sortOrder: 'desc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            const createdAt = new Date(val)
            return createdAt.toLocaleString('pt-br');
          },
        },
        {
          uniqid: 'title',
          label: 'Nome',
          field: 'title',
          visible: true,
          sortable: false,
          sortOrder: 'desc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
        },

        {
          uniqid: 'status',
          label: 'Status',
          field: 'status',
          visible: true,
          sortable: false,
          sortOrder: 'desc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            const status = {
              finish: 'Sucesso',
              failed: 'Falhou',
              processing: 'Processando',
            }

            return status[val]
          }
        },

        {
          uniqid: 'size',
          label: 'Tamanho',
          field: 'size',
          visible: true,
          sortable: false,
          sortOrder: 'desc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
          format: (val, row) => {
            if (row.file)
              return `${ (row.file.size / (1024 * 1024)).toFixed(2) }MB`
          }
        },

        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'actions',
          visible: true,
          sortable: false,
          sortOrder: 'desc',
          classes: 'px-4 py-3 border-b text-sm col-name',
          headerClass: 'p-4 text-left',
        },
      ],
      date: null,

      options: {
        salesPromoterSearch: [],
        marketNetworkSearch: [],
        marketSearch: [],
        providerSearch: [],
        brandSearch: [],
        productSearch: [],
        statesSearch: [],
        citysSearch: [],
      },

      columns: [
        {
          uniqid: 'sales_promoter_label',
          label: 'PROMOTOR',
          field: 'sales_promoter',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'market',
          label: 'MERCADO',
          field: 'market',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'provider',
          label: 'FORNECEDOR',
          field: 'provider',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'brand',
          label: 'MARCA',
          field: 'brand',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'frequency',
          label: 'FREQUÊNCIA',
          field: 'frequency',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
      ],
    }
  },

  watch: {
    'filters.MonthlyReport': {
      handler() {
        this.getFiltersFromAPI()
      },
      deep: true,
    },
  },

  created() {
    const dateFromFilter = this.getFilters().date

    if (dateFromFilter)
      this.date = new Date(dateFromFilter)

    else
      this.date = new Date()


    this.filters.MonthlyReport.date = this.$filters.formatDate(this.date, 'yyyy-MM-dd')
  },

  

  methods: {
    changeMonth (value) {
      this.date.setMonth(this.date.getMonth() + value)

      this.filters.MonthlyReport.date = this.$filters.formatDate(this.date, 'yyyy-MM-dd')
      this.reloadTable()
    },

    clearSearch () {
      this.clearFilters()
      this.getFiltersFromAPI()

      this.date = new Date()
      this.filters.MonthlyReport.date = this.$filters.formatDate(this.date, 'yyyy-MM-dd')

      this.reloadTable()
    },
    getQuery () {
      return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
    },
    reloadTable () {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    reloadExportedTable() {
      this.exportedTable = false;
      setTimeout(() => this.exportedTable = true, 10);
    },
    handlerExportXlsx(value = true) {
      this.$refs.showModalXlsx.showModal = value
    },
    closeModalExport () {
      this.$refs.showModalXlsx.showModal = false;
    },

    async handlerSendToExportData() {
      const filters = this.getFilters()

      const dataRef = new Date(this.date).toISOString()

      

      try {

        const response = await axios.post('/monthly_report/export/xlsx/' + dataRef, filters)

        if (response.status == 200)
          this.$toast.success(response.data.message)
      }

      catch (err) {
        if (axios.isAxiosError(err))
          this.$toast.error(err.response.data.message)

        else
          this.$toast.error('Erro ao fazer requisição')
      }

      this.handlerExportXlsx(false)
    },


    downloadExportedFile(id) {
      window.open(`/monthly_report/export/xlsx/download/${id}`)
    },

    async deleteExportedFile(id) {
      try {
        const response = await axios.delete(`/monthly_report/export/xlsx/${id}`)

        if (response.status == 200)
          this.$toast.success(response.data.message)
      }

      catch (err) {
        if (axios.isAxiosError(err))
          this.$toast.error(err.response.data.message)

        else
          this.$toast.error('Erro ao fazer requisição')
      }

      this.reloadExportedTable()
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent( 'MonthlyReport', { 
      sales_promoter: [],
      market_network: [],
      market: [],
      provider: [],
      brand: [],
      product: [],
      city: [],
      state: [],
      status: [],
      date: '',
    } )

    const clearFilters = () => clearFiltersComponent( 'MonthlyReport', { 
      sales_promoter: [],
      market_network: [],
      market: [],
      provider: [],
      brand: [],
      product: [],
      city: [],
      state: [],
      status: [],
      date: '',
    } )
    const getFilters = () => getFiltersComponent( 'MonthlyReport' )

    return { 
      getFilters,
      clearFilters, 
      filters: filtersStore.filters
    }
  },
}
</script>

<style scoped>
.page-title {
    font: normal normal normal 32px/38px Roboto;
    color: #828282;
    margin: 1.8rem 0;
}

.report-table-wrapper {
    background: #ffffff;
    border-radius: 6px;
}

.month-pagination-wrapper {
    display: flex;
    padding: 2.5rem 0 1.5rem 0;
    align-items: center;
    gap: 1.75rem;
    justify-content: center;
    color: #A7A7A7;
    font: normal normal normal 1.25rem Poppins
}

.table-wrapper {
    padding: 0 1rem;
}
</style>
